import { useStaticQuery, graphql } from "gatsby"

export const useWebAds = () => {

  const { allContentfulWebAd } = useStaticQuery(
    graphql`
      query AdsQuery {
        allContentfulWebAd {
          edges {
            node {
              image {
                file {
                  url
                }
              }
              link
            }
          }
        }
      }
    `
  )

  return { ads: allContentfulWebAd.edges };
}